import React, { useEffect, useState } from "react";
import { fakeRootType } from "../FakeRootType";
import { Row, Col } from "react-bootstrap";
import Button from "../Parts/Button";
import apiCalls from "../PowerShadesAPIFunctions";
import { useModal } from "../Store/ui/hooks";
import { PortfolioVM } from "../powershadesApiTypes";

type PortfolioContentProps = {
    root: fakeRootType;
};

type portfolioRowType = {
    portfolio_name: string;
    portfolio_color: string;
    header_count: number;
    part_count: number;
    fabric_count: number;
    accessory_count: number;
}

export const PortfolioContent = ({ root }: PortfolioContentProps) => {

    const [portfolios, setPortfolios] = useState<PortfolioVM[]>([]);
    const portfolioRows: portfolioRowType[] = portfolios.map(p => ({
        portfolio_name: p.name,
        portfolio_color: p.color_hex,
        header_count: p.header_count,
        part_count: p.parts_count ,
        fabric_count: p.fabrics_count,
        accessory_count: p.accessories_count
    }));    

    const modal = useModal();

    useEffect(() => {
        apiCalls.getPortfolioVMs().then(resp => {
            const portVms = resp.data.portfolios;
            
            setPortfolios(portVms);
        })
    })

    useEffect(() => {
        root.setTitle("Portfolios");
    }, [root]);

    const handleOnUpdatePortfolio = () => {
        apiCalls.updatePortfolio();
        modal({
            title: "Portfolios Now Updating",
            text: "Please wait while the portfolios are updated.",
            confirmButtonText: "OK",
            onConfirm: () => {
                console.log("Portfolios Updated");
            }   
        })
    }

    // const handleOnPartsUpdate = () => {
    //     console.log("Update Parts");
    // }

    // const handleOnFabricsUpdate = () => {
    //     console.log("Update Fabrics");
    // }   

    // const handleOnAccessoriesUpdate = () => {
    //     console.log("Update Accessories");
    // }   
    

    // Table from portolio rows.
    const table = (
        <table>
            <thead>
                <tr>
                    <th>Portfolio Name</th>
                    <th>Portfolio Color</th>
                    <th>Header Count</th>
                    <th>Part Count</th>
                    <th>Fabric Count</th>
                    <th>Accessory Count</th>
                    <th>Actions</th>    
                </tr>
            </thead>
            <tbody>
                {portfolioRows.map((row) => (
                    <tr key={row.portfolio_name}>
                        <td>{row.portfolio_name}</td>
                        <td>{row.portfolio_color}</td>
                        <td>{row.header_count}</td>
                        <td>{row.part_count}</td>
                        <td>{row.fabric_count}</td>
                        <td>{row.accessory_count}</td>
                    </tr>
                ))} 
            </tbody>    
        </table>
    )

    return (
        <Row>
            <Col>
            <Row>
                <Button onClick={handleOnUpdatePortfolio}>Update</Button>
            </Row>
                <Row>
                {table}
                </Row>
            </Col>
        </Row>
    )   

}
